export const exportFormPermissionsCsv = (
  selectedForms,
  dropdownList,
  permissionList,
  fileName = "form-permissions.csv",
) => {
  if (!selectedForms || !dropdownList) return;

  // CSV Headers
  const headers = [
    "Form Name (Key)",
    "Path",
    "Description",
    "Display Index",
    "Parent Id",
    ...permissionList.map((p) => `${p.label} (${p.key || p.value})`),
  ];

  // CSV Rows
  const rows = dropdownList.map((form) => {
    const selectedPermissions = selectedForms[form.id]?.permissions || [];

    const permissionColumns = permissionList.map((perm) => {
      return selectedPermissions.includes(perm.value) ? "Yes" : "";
    });

    return [
      `${form.name} (${form.key})`,
      form.path,
      form.description,
      form.displayIndex,
      form.parentId,
      ...permissionColumns,
    ];
  });

  // Convert to CSV string
  const csvContent = [
    headers.join(","),
    ...rows.map((row) => row.map((cell) => `"${cell}"`).join(",")),
  ].join("\n");

  // Create blob
  const blob = new Blob([csvContent], {
    type: "text/csv;charset=utf-8;",
  });

  // Download file
  const link = document.createElement("a");
  const url = URL.createObjectURL(blob);

  link.href = url;
  link.setAttribute("download", fileName);

  document.body.appendChild(link);
  link.click();

  document.body.removeChild(link);
};
